import { ButtonTriggerEvent } from '../../../common/components';
import { Account } from '../../../models/admin/account';

export class AddEventbriteEventsModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class AddEventbriteEventsModalData {
    constructor(account, events, addressFilteredEvents = [], targetCity = '', targetState = '') {
        this.account = account;
        this.events = events;
        this.addressFilteredEvents = addressFilteredEvents;
        this.targetCity = targetCity;
        this.targetState = targetState;
    }
    events: any[];
    addressFilteredEvents: any[];
    targetCity: string;
    targetState: string;
    account: Account;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/add.eventbrite.events.modal/add.eventbrite.events.modal.provider.ts